import React from 'react'
import PropTypes from 'prop-types'
import {usePopoverContext} from './popoverContext'
import {Content} from '@builder.io/sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {customComponents} from 'hec/builder'
import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import modelMap from 'hec/builder/model-map'
import {PopoverContent} from '@/components/ui/popover'

export const BuilderPopoverContent = ({
    popoverContent,
    popoverAlign,
    popoverAlignOffset,
    attributes
}) => {
    const {setPopoverOpen, handleMouseLeave} = usePopoverContext()
    const config = getConfig()

    const shouldQueryPopoverData = !popoverContent?.value
    const {
        data: popoverData,
        isLoading: isPopoverDataLoading,
        error: popoverDataError
    } = useFetchBuilderReference({
        model: modelMap.popoverContent,
        shouldQuery: shouldQueryPopoverData,
        referenceId: popoverContent?.id,
        fields: 'data'
    })

    if (isPopoverDataLoading && shouldQueryPopoverData) {
        return <></>
    }

    if (popoverDataError) {
        console.error(popoverDataError)
        return <div>There was an error fetching Popover data.</div>
    }

    const popoverContentData = popoverContent?.value || popoverData

    return (
        <PopoverContent
            alignOffset={popoverAlignOffset}
            align={popoverAlign}
            {...attributes}
            onMouseEnter={() => setPopoverOpen(true)}
            onMouseLeave={handleMouseLeave}
            data-testid="popoverContent-PopoverContent"
        >
            {popoverContentData && (
                <Content
                    model={modelMap.popoverContent}
                    content={popoverContentData}
                    apiKey={config.app.builder.api}
                    customComponents={customComponents}
                    data-testid="popoverContent"
                />
            )}
        </PopoverContent>
    )
}

BuilderPopoverContent.propTypes = {
    popoverContent: PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.object
    }),
    popoverAlign: PropTypes.string,
    popoverAlignOffset: PropTypes.number,
    attributes: PropTypes.shape({
        className: PropTypes.string
    })
}

export const PopoverContentDefinition = {
    component: BuilderPopoverContent,
    name: 'PopoverContent',
    noWrap: true,
    canHaveChildren: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    hideFromInsertMenu: true,
    inputs: [
        {
            name: 'popoverAlignOffset',
            type: 'number',
            showIf: `options.get('popoverAlign') === 'start' || options.get('popoverAlign') === 'end'`
        },
        {
            name: 'popoverAlign',
            enum: ['start', 'end', 'center']
        },
        {
            name: 'popoverContent',
            type: 'reference',
            model: modelMap.popoverContent,
            required: true
        }
    ]
}
